import { camelize, snakize } from "./stringUtils-DdV7wDb8.mjs";
import { isDate, isObjectType } from "remeda";

//#region src/objectUtils.ts
function deepLookup(data, formatFunc) {
	if (Array.isArray(data)) return data.map((datumn) => {
		return deepLookup(datumn, formatFunc);
	});
	if (isDate(data) || !isObjectType(data)) return data;
	return Object.entries(data).reduce((result, [k, v]) => {
		let value;
		if (isDate(v) || !isObjectType(v)) value = v;
		else value = deepLookup(v, formatFunc);
		Object.assign(result, { [formatFunc(k)]: value });
		return result;
	}, {});
}
function deepCamelizeKeys(data) {
	return deepLookup(data, camelize);
}
function deepSnakeizeKeys(data) {
	return deepLookup(data, snakize);
}

//#endregion
export { deepCamelizeKeys, deepSnakeizeKeys };